"use strict";

var _defineProperty = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _types = _interopRequireDefault(require("../metadata/types"));

function interpolationBuilder(interpolation) {
  return {
    getMetadata: function getMetadata() {
      return _defineProperty({}, _types.default.INTERPOLATION, interpolation);
    },
    build: function build() {
      return interpolation;
    }
  };
}

var _default = interpolationBuilder;
exports.default = _default;